import React, { useEffect, useState } from "react";
import "./Edit_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import { useDispatch } from "react-redux";
import {
  GetAll,
  GetSingle,
  Update,
} from "../../../../../../../features/admin/website/aboutus/ourStory/Slice";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { IDS } from "../../../../../../../utils/IDS";

function Edit_offcanvas({
  show,
  showError,
  setShowError,
  setShow,
  setSuccess,
  setErr,
  handleClose,
  setShowRejectModal,
}) {
  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const dispatch = useDispatch();
  const [defaultValues, setDefaultValues] = useState({});
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      description: "",
      video: "",
    },
  });
  const imageFile = watch("video");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("description", data?.description || "");

      if (data?.video && data.video.length > 0) {
        sendData.append("video", data.video[0]);
      }
      const res = await dispatch(Update({ id: data.id, data: sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());

        setModalsuccessShow(true); // ✅ SHOW SUCCESS MODAL
        setShow(false); // close offcanvas
        setSuccess(true); // optional parent flag
      } else {
        setShow(false);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);
    }
  };

  useEffect(() => {
    if (modalSuccessShow) {
      const timer = setTimeout(() => {
        setModalsuccessShow(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [modalSuccessShow]);

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      setDefaultValues({
        id: res?.payload?.data?.id,
        description: res?.payload?.data?.description,
        video: res?.payload?.data?.video,
      });
    } catch (error) {
      console.error(error);
      setShow(false);
      setErr(true);
    }
  };

  useEffect(() => {
    if (show) {
      GetData(show);
    }
  }, [show]);

  useEffect(() => {
    if (defaultValues?.id) {
      reset(defaultValues);
    }
  }, [defaultValues, reset]);

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Full Name */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Description"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("description", {
                        required: "Description is required",
                      })}
                    />
                    {errors?.description && (
                      <Form.Text className="text-danger">
                        {errors?.description?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Video</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.video,
                  })}
                  type="file"
                  accept="video/mp4"
                  {...register("video")}
                />
                {errors.video && (
                  <span className="text-danger">{errors.video.message}</span>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <Form.Group className="mb-3">
                  <Form.Label className="text-center">Video Preview</Form.Label>

                  {/* Existing video from backend */}
                  {typeof getValues("video") === "string" ? (
                    <div className="video-preview-container">
                      <video
                        src={IDS.IMG_URL + getValues("video")}
                        controls
                        width="200"
                        height="150"
                      />
                    </div>
                  ) : (
                    /* Newly selected video */
                    watch("video")?.length > 0 && (
                      <div className="video-preview-container">
                        <video
                          src={URL.createObjectURL(watch("video")[0])}
                          controls
                          width="200"
                          height="150"
                        />
                      </div>
                    )
                  )}
                </Form.Group>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Edit_offcanvas;
